// react-aria-components render open dialogs (modals, drawers, popovers built on
// Dialog) with role="dialog"/"alertdialog", marking one that is animating closed
// with data-exiting. Keyboard shortcuts consult this so Escape/next/prev defer to
// an open overlay (letting react-aria handle Escape) instead of firing beneath it.
export function isOverlayOpen(): boolean {
  return (
    document.querySelector(
      '[role="dialog"]:not([data-exiting]), [role="alertdialog"]:not([data-exiting])',
    ) != null
  );
}
